import { TOOLS } from "./toolbar/tools";

export default class GARecord {

    /**
     *
     * @type {GARecord}
     * @static
     * @memberof GARecord
     */
    static _instance;

    /**
     *
     *
     * @readonly
     * @static
     * @memberof GARecord
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new GARecord();
        }
        return this._instance;
    }

    callGoogleAnalytics(eventName, arrNames, arrs) {
        let analyticFrame = document.createElement("iframe");
        analyticFrame.id = "analytic";
        analyticFrame.width = 0;
        analyticFrame.height = 0;
        analyticFrame.style.position = "absolute";
        analyticFrame.style.left = "-4px";
        analyticFrame.style.top = "-4px";
        let src = "https://etextbook.knsh.com.tw/ftp_data/firebase/firebaseAnalytics_test.html?event=" + eventName;
        let i = 0;
        for (i = 0; i < arrNames.length; i++) {
            src += "&" + arrNames[i] + "=" + arrs[i];
        }
        analyticFrame.src = src;
        console.log("iframe src = " + src);
        document.body.appendChild(analyticFrame);
        setTimeout(function (e) {
            document.body.removeChild(analyticFrame);
        }, 1000);
    }

    bookConfigGARecord(type, year, subject, grade, name) {
        let arrNames = ['book_type', 'book_year', 'book_subject', 'book_grade', 'book_name'];
        let arrs = [type, year, subject, grade, name];
        this.callGoogleAnalytics('book_config', arrNames, arrs);
    }

    toolClickGARecord(name) {
        let tools = Object.keys(TOOLS).map((key) => {
            return TOOLS[key];
        });
        let currentTool = tools.find((tool) => {
            if (tool.TOOL == name) {
                return tool
            }
        })
        if (currentTool) {
            let arrNames = ['tool_name'];
            let arrs = [currentTool.TOOL_NAME];
            this.callGoogleAnalytics('tool_click', arrNames, arrs);

            console.log('tool_name', currentTool.TOOL_NAME)
        }
    }
}
